import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DriverCredentialService } from '../credential-service/driver-credential.service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: 'app-credentialed-drivers-list',
  templateUrl: './credentialed-drivers-list.component.html',
  styleUrls: ['./credentialed-drivers-list.component.css']
})
export class CredentialedDriversListComponent implements OnInit, OnDestroy {
  search: any;
  drivers: any;
  user: any;

  constructor(
    private sharedDataService: SharedDataService,
    private credentialDriverService: DriverCredentialService
  ) { }

  ngOnInit() {
    this.getUser();
    this.getDrivers();
  }

  getUser() {
    this.sharedDataService.getUser()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
        }
      });
  }

  getDrivers() {
    this.credentialDriverService.getDrivers()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data: any) => {
        if (data && data.length) {
          this.drivers = data;
        }
      }
      );
  }

  ngOnDestroy(): void {
  }
}
